import React from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { LocaleProvider, splitLanguagePath, useLocale } from './i18n/I18n';
import BezalelSite from './components/experience/BezalelSite';
import { ServicesPage } from './components/product/ProductShell';
import NewsPage from './components/experience/NewsPage';
import NewsDetail from './components/experience/NewsDetail';
import { NewsProvider } from './components/experience/NewsProvider';
import EditorialDashboard from './components/editorial/EditorialDashboard';
import { ServiceDetail, NotFoundPage } from './components/experience/ServicesPages';
import PageMetadata from './components/experience/PageMetadata';
import FloatingAssistant from './components/assistant/FloatingAssistant';
import { PrivacyProvider } from './components/privacy/PrivacyCenter';
import './components/experience/enhancements.css';
import './components/experience/interactions.css';

function ClientAccessPending() {
  const { href } = useLocale();
  return <Navigate to={href('/')} replace />;
}

function LocalizedRoutes() {
  const location = useLocation();
  return <><PageMetadata/><Routes location={{ ...location, pathname: splitLanguagePath(location.pathname).path }}>
    <Route path="/" element={<BezalelSite />} />
    <Route path="/acceso" element={<ClientAccessPending />} />
    <Route path="/facturacion" element={<ClientAccessPending />} />
    <Route path="/enlaces" element={<ClientAccessPending />} />
    <Route path="/noticias" element={<NewsPage />} />
    <Route path="/noticias/:id" element={<NewsDetail />} />
    <Route path="/admin/noticias" element={<EditorialDashboard />} />
    <Route path="/servicios" element={<ServicesPage />} />
    <Route path="/servicios/:slug" element={<ServiceDetail />} />
    <Route path="*" element={<NotFoundPage />} />
  </Routes><FloatingAssistant/></>;
}

export function AppRoutes() { return <LocaleProvider><PrivacyProvider><NewsProvider><LocalizedRoutes/></NewsProvider></PrivacyProvider></LocaleProvider>; }

function App() { return <BrowserRouter><AppRoutes/></BrowserRouter>; }

export default App;
